import React, { useState } from 'react';
import { Container, Form } from 'react-bootstrap';
import DomainScanner from './DomainScanner';
import ProspectingMode from './ProspectingMode';

const DomainScanners = () => {
  const [prospectingMode, setProspectingMode] = useState(false);

  return (
    <Container className="py-4">

      <div className="d-flex justify-content-end mb-3">
        <Form.Check
          type="switch"
          id="prospecting-mode-switch"
          label="Prospecting Mode"
          checked={prospectingMode}
          onChange={(e) => setProspectingMode(e.target.checked)}
        />
      </div>

      {prospectingMode ? (
        <ProspectingMode />
      ) : (
        <DomainScanner />
      )}

    </Container>
  );
};

export default DomainScanners;